<template>
  <div>
       
        <Modal
            :mask-closable="false"
            v-model="eventList.ModalEvent"
            title="项目设置"
            width="820"
            :footerHide="true"
             @on-cancel="cloesModalEvent"
        >
                <div class="cf sortEvent">
                    <label class="float-l">性别组别：</label>
                    <Select style="width:120px;" class="float-l" placeholder="请选择性别组别" v-model="sortList">
                        <Option v-for="item,index in sexGroup.SexsortregisterData" :value="item.sexSortID" :key="index">{{ item.sexSortName }}</Option>
                    </Select>
                </div>
             
                <div class="eventList">
                    <table class="sportsmanTableHead sportsmanTable">
                        <tr>
                            <th width="32">#</th>
                            <th width="200">项目名称</th>
                            <th width="110">风速</th>
                            <th width="260">赛次</th>
                            <th>器材</th>
                        </tr>
                    </table>
                    <div class="sportsmanTableTbody">
                        <table id="eventTable" class="sportsmanTable">
                            <tr @click="selectSportsman(item,index)" v-for="item,index in eventListData" :key="index">
                                <td width="32"><div class="getSportsman display-i"></div></td>
                                <td width="200">{{item.name}}<span v-if="item.allEvent">-{{item.allEvent}}</span></td>
                                <td width="110">
                                  <div @click.stop>
                                    <Select v-if="getGameNames.gameType!==1&&getGameNames.gameType!==4"   @change="speedF" size="small" v-model="item.wind" style="width:100px;margin:0 auto;">
                                        <Option v-for="item in $PlugIn.speedData" :value="item.value" :key="item.value">{{ item.label }}</Option>
                                    </Select>
                                    
                                  </div>
                                </td>
                                <td width="260"><div  v-if="!item.allPropNow" ><span v-for="i,k in item.layerData" :key="k" >{{i}} <span v-if="item.layerData.length>(k+1)">,</span> </span><Button style="margin-left:8px;" @click.stop="addlayer(item,index)"  size="small"   >添加赛次</Button></div></td>
                                <td >
                                  <div @click.stop>
                                    <Select v-if="item.equipmentData.length" size="small" v-model="item.equipment" style="width:150px;margin:0 auto;">
                                        <Option v-for="item,index in item.equipmentData" :value="item.value" :key="index">{{ item.label }}</Option>
                                    </Select>
                                  </div>
                                </td>
                            </tr>
                           
                        </table>
                    </div>
                    <div class="UpBut cf">
                        <Button class="float-l m-r10px" type="primary"  size="large" @click="goBack"   >上一步</Button>
                        <Button class="m-r10px float-r" type="primary"  size="large" @click="submitEvent"   >完成</Button>
                    </div>
                </div>
        </Modal>
         <Modal
            :mask-closable="false"
            v-model="ModalAddlayer"
            title="赛次"
            width="360"
            :footerHide="true"
        >
                <CheckboxGroup v-model="layer">
                    <Checkbox v-for="item in layerList" :key="item"  :label="item"></Checkbox>
                </CheckboxGroup>
                 <div class="UpBut cf">
                    <Button type="primary"  @click="addlayerSubmit"   >确认</Button>
                </div>
         </Modal>
  </div>
</template>

<script>
import {getEventListGameID,addEvent,getEvent} from '@/lib/api/index.js'

export default {
  props: ['gameId','eventList','resultList','sexGroup'],
  data(){
    return {
      eventObj:{},
      eventListData:[],
      sortList:'',
      ModalAddlayer:false,
      layer:['决赛'],
      layerList:[],
      layerIndex:[],
      formEventList:[]
    }
  },
  computed:{
    getGameNames()
    {
      return this.$store.state.unitAllData.gameName
    },
    modalEventChangs()
    {
        return this.eventList.ModalEvent;
    },
    groupregisterData()
    {
       return  this.sortList;
    }
    
  },
  watch: {
    groupregisterData()
    {
        for(let i = 0; i<this.getEventTable().length; i++)
        {
            this.getEventTable()[i].className = '';
        }
        this.formEventList = [];
        getEventListGameID(this.gameId).then(res => {
            if(res.data.code == 0){
                // EventTypeTrack(1, "径赛"), 
                // EventTypeHigh(2, "田高"), 
                // EventTypeFar(3, "田远"), 
                // EventTypeRelay(4,"接力"), 
                // EventTypeAll(5, "全能"),
                // EventTypeWalk(6, "竞走"),
                // EventTypeMarathon(7, "马拉松")
                this.eventListData = [];
                if(this.getGameNames.gameType===1||this.getGameNames.gameType===4)
                {
                this.getEventListData(res.data.data,1);
                }else{
                this.getEventListData(res.data.data);
                }
            }else if(res.data.code == -2){
                this.$Message.error("获取失败");
            }else if(res.data.code==10)
            {
                this.$Message.info("登录token过期请重新登录");
                this.$store.dispatch('loginOut');
            }else{
                this.$Message.error(res.data.msg);
            }
        },err =>{
            this.$Message.error("网络连接失败");
        });
    },
    modalEventChangs()
    {
        this.eventListData = [];
    }
  },
  methods:{
      speedF(v)
      {
         
      },
      goBack()
      {

        
        this.$emit('groupListShow');
        this.eventListData = [];
        this.sortList = '';
      },
      cloesModalEvent()
      {
          this.eventListData = [];
          this.sortList = '';
      },
      setEquipment(key,sortNameCHNNum)
      {
          if(this.eventList.ModalEvent)
          {
              this.eventListData[key].equipment =  this.eventListData[key].equipmentData[sortNameCHNNum].value;
          }
      },
      getEventListData(data,wind)
      {
            let sex = '';
            let sortNameCHNNum = '';
            
            this.sexGroup.SexsortregisterData.filter((item)=>{
                if(item.sexSortID == this.sortList)
                {
                    sex = item.sex ? item.sex : 0;
                    sortNameCHNNum = item.sortType ?  item.sortType : 0;
                }
                
            });
            console.log(this.sexGroup.SexsortregisterData,444)
            
            data.forEach((val,key) => {
                    val.sex = sex;
                    val.sortType = sortNameCHNNum;
                    if(wind)
                    {
                        val.wind = 0;
                    }else{
                        if(val.name=='100米'||val.name=='200米'||val.name=='100米栏'||val.name=='110米栏'||val.name=='三级跳远'||val.name=='跳远')
                        {
                            val.wind = 1;
                        }else{
                            val.wind = 0;
                        }
                    }
                    
                    if(val.property===3||val.property===2)
                    {
                        val.layer = ['及格赛','决赛'];
                        this.eventListData.push(val);
                        val.layerData = [];
                        val.allPropNow = false;
                    }else if(val.property===1||val.property===4||val.property===6||val.property===7)
                    {
                        val.layer = ['预赛','次赛','半决赛','决赛'];
                        this.eventListData.push(val);
                        val.layerData = [];
                        val.allPropNow = false;
                    }else{
                        val.allPropNow = true;
                        this.eventListData.push(val);
                    }

                    this.eventListData[key].equipmentData = [];
                    if(val.name=='50米栏')
                    {
                        if(sex===1)
                        {
                                this.eventListData[key].equipmentData = [
                                    {
                                        label:'成年女子（0.838m）',
                                        value:'0.838m'
                                    },
                                    {
                                        label:'U20青年女子（0.838m）',
                                        value:'0.838m'
                                    },
                                    {
                                        label:'U18少年女子（0.762m）',
                                        value:'0.762m'
                                    },
                                     {
                                        label:'其他',
                                        value:'其他'
                                    },
                                ]
                        }
                        else
                        {

                            this.eventListData[key].equipmentData = [
                                {
                                    label:'成年男子（1.067m）',
                                    value:'1.067m'
                                },
                                {
                                    label:'U20青年男子（0.991m）',
                                    value:'0.991m'
                                },
                                {
                                    label:'U18少年男子（0.914m）',
                                    value:'0.914m'
                                },
                                {
                                    label:'其他',
                                    value:'其他'
                                },
                            ]
                            
                        }

                        this.setEquipment(key,sortNameCHNNum);
                    }else if(val.name=='60米栏')
                    {
                        if(sex===1)
                        {
                                this.eventListData[key].equipmentData = [
                                    {
                                        label:'成年女子（0.838m）',
                                        value:'0.838m'
                                    },
                                    {
                                        label:'U20青年女子（0.838m）',
                                        value:'0.838m'
                                    },
                                    {
                                        label:'U18少年女子（0.762m）',
                                        value:'0.762m'
                                    },
                                     {
                                        label:'其他',
                                        value:'其他'
                                    },
                                ]
                        }
                        else
                        {

                            this.eventListData[key].equipmentData = [
                                {
                                    label:'成年男子（1.067m）',
                                    value:'1.067m'
                                },
                                {
                                    label:'U20青年男子（0.991m）',
                                    value:'0.991m'
                                },
                                {
                                    label:'U18少年男子（0.914m）',
                                    value:'0.914m'
                                },
                                {
                                    label:'其他',
                                    value:'其他'
                                },
                            ]
                            
                        }
                        this.setEquipment(key,sortNameCHNNum);
                    }else if(val.name=='110米栏')
                    {
                        if(sex===0)
                        {

                            this.eventListData[key].equipmentData = [
                                {
                                    label:'成年男子（1.067m）',
                                    value:'1.067m'
                                },
                                {
                                    label:'U20青年男子（0.991m）',
                                    value:'0.991m'
                                },
                                {
                                    label:'U18少年男子（0.914m）',
                                    value:'0.914m'
                                },
                                 {
                                    label:'其他',
                                    value:'其他'
                                },
                            ]
                            this.setEquipment(key,sortNameCHNNum);
                            
                        }
                        
                    }else if(val.name=='100米栏')
                    {
                        if(sex===1)
                        {
                                this.eventListData[key].equipmentData = [
                                    {
                                        label:'成年女子（0.838m）',
                                        value:'0.838m'
                                    },
                                    {
                                        label:'U20青年女子（0.838m）',
                                        value:'0.838m'
                                    },
                                    {
                                        label:'U18少年女子（0.762m）',
                                        value:'0.762m'
                                    },
                                     {
                                        label:'其他',
                                        value:'其他'
                                    },
                                ]
                                this.setEquipment(key,sortNameCHNNum);
                        }
                        
                        
                    }else if(val.name=='400米栏')
                    {
                        if(sex===1)
                        {
                                this.eventListData[key].equipmentData = [
                                    {
                                        label:'成年女子（0.762m）',
                                        value:'0.762m'
                                    },
                                    {
                                        label:'U20青年女子（0.762m）',
                                        value:'0.762m'
                                    },
                                    {
                                        label:'U18少年女子（0.762m）',
                                        value:'0.762m'
                                    },
                                     {
                                        label:'其他',
                                        value:'其他'
                                    },
                                ]
                        }
                        else
                        {

                            this.eventListData[key].equipmentData = [
                                {
                                    label:'成年男子（0.914m）',
                                    value:'0.914m'
                                },
                                {
                                    label:'U20青年男子（0.914m）',
                                    value:'0.914m'
                                },
                                {
                                    label:'U18少年男子（0.838m）',
                                    value:'0.838m'
                                },
                                {
                                    label:'其他',
                                    value:'其他'
                                },
                            ]
                            
                        }
                        this.setEquipment(key,sortNameCHNNum);
                    }else if(val.name=='2000米障碍')
                    {
                        if(sex===1)
                        {
                                this.eventListData[key].equipmentData = [
                                    {
                                        label:'女子（0.762m）',
                                        value:'0.762m'
                                    },
                                    {
                                        label:'其他',
                                        value:'其他'
                                    },
                                ]
                        }
                        else
                        {

                            this.eventListData[key].equipmentData = [
                                {
                                    label:'男子（0.914m）',
                                    value:'0.914m'
                                },
                                {
                                    label:'其他',
                                    value:'其他'
                                },
                            ]
                            
                        }
                        this.setEquipment(key,0);
                    }else if(val.name=='3000米障碍')
                    {
                        if(sex===1)
                        {
                                this.eventListData[key].equipmentData = [
                                    {
                                        label:'女子（0.762m）',
                                        value:'0.762m'
                                    },
                                    {
                                        label:'其他',
                                        value:'其他'
                                    },
                                ]
                        }
                        else
                        {
                            this.eventListData[key].equipmentData = [
                                {
                                    label:'男子（0.914m）',
                                    value:'0.914m'
                                },
                                 {
                                    label:'其他',
                                    value:'其他'
                                },
                                
                            ]
                            
                        }
                        this.setEquipment(key,0);
                    }else if(val.name=='铅球')
                    {
                        if(sex===1)
                        {
                                this.eventListData[key].equipmentData = [
                                    {
                                        label:'成年女子（4.000kg）',
                                        value:'4.000kg'
                                    },
                                    {
                                        label:'U20青年女子（4.000kg）',
                                        value:'4.000kg'
                                    },
                                    {
                                        label:'U18少年女子（3.000kg）',
                                        value:'3.000kg'
                                    },
                                     {
                                        label:'其他',
                                        value:'其他'
                                    },
                                ]
                        }
                        else
                        {

                            this.eventListData[key].equipmentData = [
                                {
                                    label:'成年男子（7.260kg）',
                                    value:'7.260kg'
                                },
                                {
                                    label:'U20青年男子（6.000kg）',
                                    value:'6.000kg'
                                },
                                {
                                    label:'U18少年男子（5.000kg）',
                                    value:'5.000kg'
                                },
                                 {
                                    label:'其他',
                                    value:'其他'
                                },
                            ]
                            
                        }
                        this.setEquipment(key,sortNameCHNNum);
                    }else if(val.name=='铁饼')
                    {
                        if(sex===1)
                        {
                                this.eventListData[key].equipmentData = [
                                    {
                                        label:'成年女子（1.000kg）',
                                        value:'1.000kg'
                                    },
                                    {
                                        label:'U20青年女子（1.000kg）',
                                        value:'1.000kg'
                                    },
                                    {
                                        label:'U18少年女子（1.000kg）',
                                        value:'1.000kg'
                                    },
                                    {
                                        label:'其他',
                                        value:'其他'
                                    },
                                ]
                        }
                        else
                        {

                            this.eventListData[key].equipmentData = [
                                {
                                    label:'成年男子（2.000kg）',
                                    value:'2.000kg'
                                },
                                {
                                    label:'U20青年男子（1.750kg）',
                                    value:'1.750kg'
                                },
                                {
                                    label:'U18少年男子（1.500kg）',
                                    value:'1.500kg'
                                },
                                {
                                    label:'其他',
                                    value:'其他'
                                },
                            ]
                            
                        }
                        this.setEquipment(key,sortNameCHNNum);
                    }else if(val.name=='链球')
                    {
                        if(sex===1)
                        {
                                this.eventListData[key].equipmentData = [
                                    {
                                        label:'成年女子（4.000kg）',
                                        value:'4.000kg'
                                    },
                                    {
                                        label:'U20青年女子（4.000kg）',
                                        value:'4.000kg'
                                    },
                                    {
                                        label:'U18少年女子（3.000kg）',
                                        value:'3.000kg'
                                    },
                                     {
                                        label:'其他',
                                        value:'其他'
                                    },
                                ]
                        }
                        else
                        {

                            this.eventListData[key].equipmentData = [
                                {
                                    label:'成年男子（7.260kg）',
                                    value:'7.260kg'
                                },
                                {
                                    label:'U20青年男子（6.000kg）',
                                    value:'6.000kg'
                                },
                                {
                                    label:'U18少年男子（5.000kg）',
                                    value:'5.000kg'
                                },
                                 {
                                    label:'其他',
                                    value:'其他'
                                },
                            ]
                            
                        }
                        this.setEquipment(key,sortNameCHNNum);
                    }else if(val.name=='标枪')
                    {
                        if(sex===1)
                        {
                                this.eventListData[key].equipmentData = [
                                    {
                                        label:'成年女子（600g）',
                                        value:'600kg'
                                    },
                                    {
                                        label:'U20青年女子（600g）',
                                        value:'600kg'
                                    },
                                    {
                                        label:'U18少年女子（500g）',
                                        value:'500g'
                                    },
                                     {
                                        label:'其他',
                                        value:'其他'
                                    },
                                ]
                        }
                        else
                        {

                            this.eventListData[key].equipmentData = [
                                {
                                    label:'成年男子（800g）',
                                    value:'800g'
                                },
                                {
                                    label:'U20青年男子（800g）',
                                    value:'800g'
                                },
                                {
                                    label:'U18少年男子（700g）',
                                    value:'700g'
                                },
                                {
                                    label:'其他',
                                    value:'其他'
                                },
                            ]
                            
                        }
                        this.setEquipment(key,sortNameCHNNum);
                    }

                   
            });
            
            
      },
      submitEvent()
      {
        
        let data = [];
        let num = 0;
        
        this.formEventList.forEach((v,k) => {
            if(v.data.property===5)
            {
                data.push({
                    gameID : this.getGameNames.gameID,
                    sexSortEventLayerID: -1,
                    sexSortID: this.sortList,
                    event:v.data.name,
                    equipment:v.data.equipment,
                    property:v.data.property,
                    allProp:v.data.allProp,
                    wind:v.data.wind,
                    sortType:v.data.sortType,
                    // sex:v.data.sex,
                    allEvent:v.data.allEvent,
                    layerName:'决赛'
                });
            }else{
                
                if(v.data.layerData)
                {console.log(typeof v.data.layerData)
                    if(v.data.layerData.length>1)
                    {
                        console.log(data.layerData,222)
                        for(let i = 0; i<v.data.layerData.length;i++)
                        {
                            data.push({
                                gameID : this.getGameNames.gameID,
                                sexSortEventLayerID: -1,
                                sexSortID: this.sortList,
                                event:v.data.name,
                                property:v.data.property,
                                wind:v.data.wind,
                                equipment:v.data.equipment,
                                sortType:v.data.sortType,
                                // sex:v.data.sex,
                                allProp:0,
                                layerName:v.data.layerData[i]
                            });
                        }
                    }else if(v.data.layerData.length){

                        data.push({
                            gameID : this.getGameNames.gameID,
                            sexSortEventLayerID: -1,
                            sexSortID: this.sortList,
                            event:v.data.name,
                            property:v.data.property,
                            wind:v.data.wind,
                            sortType:v.data.sortType,
                            // sex:v.data.sex,
                            equipment:v.data.equipment,
                            allProp:0,
                            layerName:v.data.layerData[0]
                        });
                    }else{
                        num++;
                    }  
                }else{
                    data.push({
                        gameID : this.getGameNames.gameID,
                        sexSortEventLayerID: -1,
                        sexSortID: this.sortList,
                        event:v.data.name,
                        property:v.data.property,
                        wind:v.data.wind,
                        sortType:v.data.sortType,
                        // sex:v.data.sex,
                        equipment:v.data.equipment,
                        allProp:0,
                        layerName:'决赛'
                    });
                }
               
            }     
        });
        
           
        if(data.length>0)
        {
            addEvent(data).then(res => {
                if(res.data.code == 0){
                    this.eventListData = [];
                    this.$emit('showModalEvent');
                    this.sortList = '';
                    this.$Message.info("添加成功");
                    
                }else if(res.data.code == -2){
                    this.$Message.error("获取失败");
                }else if(res.data.code==10)
                {
                    this.$Message.info("登录token过期请重新登录");
                    this.$store.dispatch('loginOut');
                }else{
                    this.$Message.error(res.data.msg);
                }
            },err =>{
                this.$Message.error("网络连接失败");
            });
        }
        if(num)
        {
            this.$Message.info("有"+num+"个勾选项目没有选择赛次");
        }
      },
      getEventTable()
      {
          return document.getElementById('eventTable').getElementsByTagName('tr');
      },
      selectSportsman(item,index)
      {
          if(this.getEventTable()[index].className === 'on')
          {
            this.getEventTable()[index].className = '';
            for(let i = 0; i<this.formEventList.length;i++)
            {
                if(index===this.formEventList[i].index)
                {
                    this.formEventList.splice(i, 1);
                }
            }
            
          }else{
            this.getEventTable()[index].className = 'on';
            this.formEventList.push({
                data:item,
                index:index
            });
          }
          
      },
      addlayer(obj,index)
      {
          this.ModalAddlayer = true;
          this.layerList = obj.layer;
          this.eventObj = obj;
          this.layerIndex = index;
          
      },
      addlayerSubmit()
      {
          this.ModalAddlayer = false;
          this.eventListData[this.layerIndex].layerData = this.layer;
          
        //   this.selectSportsman(this.eventObj,this.layerIndex);
      }
      
     

  },
  created(){},
  mounted(){
     

  },
 
    
}
</script>
<style scoped  lang="less">
    .GroupUpBut{
      padding-top: 22px;
    }
    .UpBut{padding-top: 22px;}
     .sportsmanTable{width: 100%;text-align: center;}
    .sportsmanTableTbody{max-height: 360px;overflow-y:auto;margin-top: -1px;border-bottom: 1px solid #ddd;}
    .sportsmanTableHead{margin-top: 12px;}
    .sportsmanTable ,.sportsmanTable th,.sportsmanTable td{border: 1px solid #ddd;border-collapse: collapse;}
    .sportsmanTable th,.sportsmanTable td{padding: 6px 3px;}
    .sportsmanSubmit{padding-top: 22px;}
    .getSportsman{height: 12px;width: 12px;background: #ccc;box-shadow: 1px 1px 1px #999;}
    .sportsmanTable tr.on .getSportsman{background: #30a5ff;}
    .sportsmanTable tr.on td{background: #eee;}
    .sortEvent{line-height: 30px;}
</style>





// WEBPACK FOOTER //
// src/components/event.vue